import { Menu, MenuItem, MenuProps, PaperProps, Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ConfirmButton, MobileSelectMenu } from '../../responsiveSelect/mobileSelect';
import { ShareButtonLink } from '../shareButtonLink';
import { MobileMenuStylesProps, ShareLinkItem } from '../types';

const useStyles = makeStyles<MobileMenuStylesProps>({ name: 'ShareButtonMobileMenu' })((theme, props) => ({
	menuList: {
		padding: 0,
		display: props.centerMenuItems && 'grid',
		justifyContent: props.centerMenuItems && 'center'
	},
	menuItem: {
		padding: 0
	},
	confirmButton: {
		marginBottom: 15
	},
	linkLabel: {
		fontSize: 18,
		lineHeight: '28px'
	},
	linkRoot: {
		gap: 41
	}
}));

export type ShareButtonMobileMenuProps = Omit<MenuProps, 'children'> & {
	textCancel: string;
	textConfirm: string;
	onClose: () => void;
	centerMenuItems: boolean;
	items: ShareLinkItem[];
};

export const ShareButtonMobileMenu: React.FC<ShareButtonMobileMenuProps> = (props) => {
	const { textCancel, textConfirm, onClose, centerMenuItems, items, ...other } = props;

	const { classes, cx } = useStyles({ centerMenuItems });

	const [selectedIndex, setSelectedIndex] = React.useState(-1);

	const closeMenu = () => {
		onClose?.();
		setSelectedIndex(-1);
	};

	const confirmButtonBase = <ConfirmButton text={textConfirm} enable={selectedIndex !== -1} onClick={closeMenu} />;

	const confirmButton = selectedIndex !== -1 ? items[selectedIndex].createShareLink(confirmButtonBase, classes.confirmButton) : confirmButtonBase;

	const createMenuItem = (shareLinkItem: ShareLinkItem) => {
		return <ShareButtonLink Icon={shareLinkItem.Icon} label={shareLinkItem.label} classes={{ label: classes.linkLabel, root: classes.linkRoot }} />;
	};

	return (
		<Menu
			{...other}
			onClose={closeMenu}
			classes={{ list: classes.menuList }}
			BackdropProps={{ onClick: closeMenu }}
			PaperProps={{ component: MobileSelectMenu, square: true, dark: true, textCancel, onCancel: closeMenu, confirmButton } as PaperProps}
			TransitionComponent={Slide}
			TransitionProps={{ direction: 'up' } as TransitionProps}>
			{items.map((shareLinkItem, index) =>
				<MenuItem className={cx(classes.menuItem, 'dark')} selected={selectedIndex === index} onClick={() => setSelectedIndex(index)}>
					{createMenuItem(shareLinkItem)}
				</MenuItem>)}
		</Menu>
	);
};
